import { useMutation } from '@tanstack/react-query';

import { generateEstimate } from '../../api/generateEstimate';

export const useGenerateEstimateQuery = () =>
    useMutation({
        mutationKey: ['generateEstimate'],
        mutationFn: generateEstimate,
    });
